module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Black.0dbac0737787cb5b5ad191f3a2768444.woff2";